import { createAction } from 'typesafe-actions';

export const setFanScheduleDrafts = createAction('SCHEDULE/SET_FAN_SCHEDULE_DRAFTS', (resolve) => {
  return (payload: { start_epoch: Date; end_epoch: Date }[]) => resolve(payload);
});
